export * from "./productDetailMenu";
